var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"m-2 d-flex justify-content-center align-items-center",attrs:{"size":"lg","variant":"outline-dark"},on:{"click":_vm.show}},[_c('i',{staticClass:"fab fa-google-drive fa-2x"})])}
var staticRenderFns = []

export { render, staticRenderFns }